import { Mixpanel } from './core'
import Constants from './constants'

export const trackStartButtonClick = () => {
  Mixpanel.track(Constants.START_CLICK)
}
